import React, { useState, useEffect, createContext, useContext, useCallback } from 'react';
//import { getUser, signIn as sendSignInRequest } from '../api/auth';
import auth from '../api/auth';

function AuthProvider(props) {
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);
  const [pendingSelection, setPendingSelection] = useState(null);

  useEffect(() => {
    (async function () {
      const result = await auth.getUser();
      if (result.isOk) {
        setUser(result.data);
      }

      setLoading(false);
    })();
  }, []);

  const signIn = useCallback(async (email, password) => {
    const result = await auth.signIn(email, password);
    if (result.isOk && result.requiresTenantSelection) {
      setPendingSelection({ preAuthToken: result.preAuthToken, tenancies: result.tenancies });
    } else if (result.isOk) {
      setUser(result.data);
    }

    return result;
  }, []);

  const selectTenancy = useCallback(async (preAuthToken, tenantId) => {
    const result = await auth.selectTenancy(preAuthToken, tenantId);
    if (result.isOk) {
      setPendingSelection(null);
      setUser(result.data);
    }
    return result;
  }, []);

  const signOut = useCallback(() => {
    localStorage.clear();
    setPendingSelection(null);
    setUser();
    window.location.reload();
  }, []);


  return (
    <AuthContext.Provider value={{ user, signIn, signOut, loading, pendingSelection, selectTenancy }} {...props} />
  );
}

const AuthContext = createContext({});
const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth }
